/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import Modal from '../../Common/Modal';
import api from '../../../utils/muApi';
import { addSubscription, errorHandler, showRegister } from '../../../utils/gigyaScreen';
import { showLogin } from '../../../utils/gigyaScreen';
import { useSponsorValue } from '../../../context/sponsorContext';
import Loader from '../../Common/Loader';
import ImageFallback from '../../Common/ImageFallback';
import MU from '../../../constants/muConstants';
import { GET_UNITED_BENEFITS, GET_UNITED_BENEFITS_MUTV } from '../../../constants/endpoints';
import { ACCOUNT_SUBSCRIPTION, ANONYMOUS, REGISTERED } from '../../../constants/globalConstants';
import { userLoginStatus } from '../../../actions/sponsorAction';
import {
  createBaseUrl,
  checkSubscription,
  checkDevice,
  getMobileOperatingSystem,
} from '../../../utils/utils';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { toggleAria } from './CBRModalAcessibility';
import * as track from '../../../utils/analytics';
import {
  contentLoginFlow,
  redirectToIDMMUTVSignUp,
  redirectToIDMSignUp,
  removeUserData,
} from '../../../utils/idmUtils';

export const RegistrationModal = (props) => {
  const {
    t,
    closeModal,
    showClose = true,
    successCallback = false,
    isDestinationPage = false,
    previousActiveElement = '',
    accessType,
    analyticsObj,
  } = props;
  const [response, setResponse] = useState({ loader: true });
  const [{ userLoginDetail, isUserLogin, userConsent }, dispatch] = useSponsorValue();

  const subscriptionText = MU?.eventCalendar?.subscriptionText;
  const subscriptionQRcodeImage = MU?.eventCalendar?.subscriptionQRcodeImage;
  const subscriptionisIneligibleCountry = MU?.eventCalendar?.subscriptionisIneligibleCountry;
  const subscriptionIosUrl = MU?.eventCalendar?.subscriptionIosUrl;
  const subscriptionAndroidUrl = MU?.eventCalendar?.subscriptionAndroidUrl;
  useEffect(() => {
    const isRegistered = accessType === REGISTERED;
    fetchUnitedBenefits(isRegistered);
    if (!(isDestinationPage && MU && MU.isCurrentGeoinConsentList)) {
      const obj = getAnalytics(isRegistered, false);
      obj && track.analytics(obj);
    }
  }, []);

  useEffect(() => {
    if (isDestinationPage && userConsent) {
      const obj = getAnalytics(accessType === REGISTERED, false);
      setTimeout(() => {
        obj && track.analytics(obj);
      }, 1000);
    }
  }, [userConsent]);

  const getAnalytics = (isRegistered, flag) => {
    let obj = { trackType: isRegistered ? 'registrationBenefits' : 'subscriptionBenefit' };
    if (flag) {
      obj.container_type = isRegistered ? 'registration-benefit' : 'subscription-benefit';
    }
    if (analyticsObj) {
      return { ...analyticsObj, ...obj };
    }
    return obj;
  };

  const getLoginDetail = () => {
    if (!MU.isIDMEnabled) {
      if (window.gigya) {
        var evalResponse = function (response) {
          if (response.errorCode == 0) {
            userLoginStatus(dispatch, response);
            const isSubscribedContent = accessType === ACCOUNT_SUBSCRIPTION;
            const userSubscribed = checkSubscription(response);
            if (!isSubscribedContent || (isSubscribedContent && userSubscribed)) {
              !showClose && closeModal(); //destination pages
              successCallback && successCallback({ showContent: true });
            }
          } else {
            userLoginStatus(dispatch, false);
            errorHandler(response);
          }
        };
        window.gigya && window.gigya.accounts.getAccountInfo({ callback: evalResponse });
      }
    } else {
      const isSubscribedContent = accessType === ACCOUNT_SUBSCRIPTION;
      return successCallback && successCallback({ showContent: true, isSubscribedContent });
    }
  };
  const getLogoImg = (response) => {
    let imageDetails =
      response &&
      response.ImageDetails &&
      response.ImageDetails.find(
        (item) =>
          item.Name ===
          (accessType === REGISTERED ? 'RegistrationModelLogoWeb' : 'SubscriptionModelLogoWeb')
      );
    let src;
    if (MU && MU.assetUrl && imageDetails && imageDetails.CropUrl) {
      src = `${MU.assetUrl}/${imageDetails.CropUrl.img1x}`;
    }
    return src ? (
      <ImageFallback
        src={src}
        onErrorClass={'no-img'}
        alt={imageDetails && imageDetails.AltText}
        relativePath={false}
      />
    ) : null;
  };
  const sessionStorageData = (getData, key, obj) => {
    if (getData) {
      return sessionStorage.getItem(key);
    } else {
      const value = obj ? obj : null;
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  };

  const fetchUnitedBenefits = (isRegBadge) => {
    const sessionRegUnitedPage = isRegBadge && sessionStorageData(true, 'regUnitedPage');
    const sessionRegUnitedPageText = isRegBadge && sessionStorageData(true, 'regUnitedPageText');
    const sessionSubUnitedPage = !isRegBadge && sessionStorageData(true, 'subUnitedPage');
    const sessionSubUnitedPageText = !isRegBadge && sessionStorageData(true, 'subUnitedPageText');
    const sessionUtdPageLang = sessionStorageData(
      true,
      isRegBadge ? 'regUnitedPageLang' : 'subUnitedPageLang'
    );
    const sessionUnitedPageLang = sessionUtdPageLang && JSON.parse(sessionUtdPageLang);
    const alreadyInStorage =
      sessionUnitedPageLang && MU && MU.language && sessionUnitedPageLang === MU.language;
    if (alreadyInStorage && sessionRegUnitedPageText) {
      setResponse({
        unitedPage: sessionRegUnitedPage && JSON.parse(sessionRegUnitedPage),
        unitedPageText: JSON.parse(sessionRegUnitedPageText),
        loader: false,
      });
    } else if (alreadyInStorage && sessionSubUnitedPageText) {
      setResponse({
        unitedPage: sessionSubUnitedPage && JSON.parse(sessionSubUnitedPage),
        unitedPageText: JSON.parse(sessionSubUnitedPageText),
        loader: false,
      });
    } else {
      const route = isRegBadge ? GET_UNITED_BENEFITS : GET_UNITED_BENEFITS_MUTV;
      const apiNode = isRegBadge ? 'UnitedBenefitsResponse' : 'MutvBenefitsResponse';
      return api
        .get({ route })
        .then((data) => {
          const newVal =
            data &&
            data.data &&
            data.data[apiNode] &&
            data.data[apiNode].grouped &&
            data.data[apiNode].grouped.contenttype_t &&
            data.data[apiNode].grouped.contenttype_t.groups;
          if (newVal && newVal.length > 0) {
            const unitedPageRaw = newVal.find(
              (item) => item.groupValue === (isRegBadge ? 'benefitfeature' : 'benefitfeature')
            );
            const unitedPageTextRaw = newVal.find(
              (item) => item.groupValue === (isRegBadge ? 'benefitsset' : 'mutvbenefits')
            );
            const unitedPage = unitedPageRaw && unitedPageRaw.doclist && unitedPageRaw.doclist.docs;
            const unitedPageText =
              unitedPageTextRaw &&
              unitedPageTextRaw.doclist &&
              unitedPageTextRaw.doclist.docs &&
              unitedPageTextRaw.doclist.docs[0];
            sessionStorageData(false, isRegBadge ? 'regUnitedPage' : 'subUnitedPage', unitedPage);
            sessionStorageData(
              false,
              isRegBadge ? 'regUnitedPageText' : 'subUnitedPageText',
              unitedPageText
            );
            sessionStorageData(
              false,
              isRegBadge ? 'regUnitedPageLang' : 'subUnitedPageLang',
              MU && MU.language
            );
            setResponse({
              unitedPage: unitedPage,
              unitedPageText: unitedPageText,
              loader: false,
            });
          }
        })
        .catch((err) => {});
    }
  };
  const openRegister = (e) => {
    e.preventDefault();
    const isRegistered = accessType === REGISTERED;
    if (subscriptionisIneligibleCountry && checkDevice()) {
      const getMobileOS = getMobileOperatingSystem();
      if (getMobileOS === 'iOS' && subscriptionIosUrl) {
        if (typeof window !== 'undefined') window.location = subscriptionIosUrl;
      } else if (
        (getMobileOS === 'Android' || getMobileOS === 'Windows Phone') &&
        subscriptionAndroidUrl
      ) {
        if (typeof window !== 'undefined') window.location = subscriptionAndroidUrl;
      }
    } else if (MU.isIDMEnabled) {
      removeUserData();
      // enable IDM login flow
      if (isUserLogin && userLoginDetail && userLoginDetail.UID) {
        addSubscription({ param: userLoginDetail.UID, type: 'uid' });
      } else if (!isRegistered) {
        redirectToIDMMUTVSignUp();
      } else {
        redirectToIDMSignUp();
      }
    } else {
      showClose && closeModal(); //close registration modal on sign-up click
      const obj = getAnalytics(isRegistered, true);
      if (isUserLogin && userLoginDetail && userLoginDetail.UID) {
        obj.trackType = 'addSubscription';
        obj.destination_url = MU && MU.addSubscriptionUrl;
        delete obj.created_datetime;
        track.analytics(obj);
        addSubscription({ param: userLoginDetail.UID, type: 'uid' });
      } else {
        showRegister(getLoginDetail, true, !isRegistered, obj);
      }
    }
  };
  const openLogin = (e) => {
    e.preventDefault();
    if (MU.isIDMEnabled) {
      contentLoginFlow(getLoginDetail); // enable IDM login flow
    } else {
      const isRegistered = accessType === REGISTERED;
      showClose && closeModal(); //close registration modal on login click
      const obj = getAnalytics(isRegistered, true);
      showLogin(getLoginDetail, true, !isRegistered, obj);
    }
  };
  const getCommonData = () => {
    const obj = {};
    if (accessType === REGISTERED) {
      obj.title = response.unitedPageText && response.unitedPageText.registrationmodeltitleweb_t;
      obj.subText =
        response.unitedPageText && response.unitedPageText.registrationmodelregistrationtextweb_t;
      obj.benefitText =
        response.unitedPageText && response.unitedPageText.registrationmodeltilesheadingapp_t;
    } else {
      obj.title = response.unitedPageText && response.unitedPageText.subscriptionmodeltitleweb_t;
      obj.subText =
        response.unitedPageText && response.unitedPageText.subscriptionmodelregistrationtextweb_t;
      obj.benefitText = response.unitedPageText && response.unitedPageText.webmutvtitletext_t;
    }
    return obj;
  };
  const { title, subText, benefitText } = getCommonData();
  const getHref = () => {
    const language = MU.language ? MU.language : '';
    return `${createBaseUrl()}/${language}`;
  };

  const onClose = () => {
    toggleAria(false);
  };

  const clearSearchPageUrl = () => {
    if (sessionStorage.getItem('currentSearchPageURL')) {
      sessionStorage.removeItem('currentSearchPageURL');
    }
  };

  return (
    <React.Fragment>
      {!isDestinationPage && response && response.loader && <Loader style={{ zIndex: 9999999 }} />}
      {response && response.unitedPageText && (
        <Modal
          showClose={showClose}
          containerClass="dialog registration-modal"
          closeModal={closeModal}
          animate={true}
          previousActiveElement={previousActiveElement}
          ariaDescribedBy="dialogMesg"
          onClose={onClose}
        >
          <div className="cbr-wrapper">
            <div className="cbr-top">
              {response.unitedPageText.celumimagesvariant_s && (
                <div className="icon-mutv-modal-logo">
                  {getLogoImg(response.unitedPageText.celumimagesvariant_s)}
                </div>
              )}
              {title && <h2 id="dialogMesg">{title}</h2>}
              {!isUserLogin && (
                <p className="inline-text">
                  {`${subText ? subText : ''} `}
                  <a href="/#" onClick={(e) => openLogin(e)} role="button">
                    <span>{t('LogIn')}</span>
                  </a>
                </p>
              )}
              {MU &&
                MU.subscriptionModelRegistrationSubTextWeb &&
                accessType === ACCOUNT_SUBSCRIPTION && (
                  <RichText
                    className="inline-text subs-text"
                    tag="p"
                    field={{ value: MU.subscriptionModelRegistrationSubTextWeb }}
                  ></RichText>
                )}
              {subscriptionisIneligibleCountry && (
                <div className="qr_box">
                  {subscriptionText && <p>{subscriptionText}</p>}
                  {!checkDevice() && subscriptionQRcodeImage && (
                    <div className="QRcodeImage">
                      <img src={subscriptionQRcodeImage} alt="subscriptionQRcodeImage" />
                    </div>
                  )}
                </div>
              )}
              {((subscriptionisIneligibleCountry && checkDevice()) ||
                !subscriptionisIneligibleCountry) && (
                <div
                  className={`align-center ${
                    subscriptionisIneligibleCountry ? 'isIneligible' : ''
                  }`}
                >
                  <div className="red-btn-skew" onClick={(e) => openRegister(e)}>
                    <a href="/#" rel="noopener noreferrer" role="button">
                      <span>{`${
                        accessType === REGISTERED ? t('SignUp') : t('SubscribeNow')
                      }`}</span>
                      <i className="icon-follow-live"></i>
                    </a>
                  </div>
                </div>
              )}
              {!showClose && (
                <div
                  className={`align-center ${
                    subscriptionisIneligibleCountry ? 'isIneligible' : ''
                  }`}
                >
                  <div className="match-item__cta">
                    <a
                      href={getHref()}
                      onClick={clearSearchPageUrl()}
                      rel="noopener noreferrer"
                      role="button"
                    >
                      <span>{t('GoToHomePage')}</span>
                      <i className="icon-follow-live"></i>
                    </a>
                  </div>
                </div>
              )}
              {benefitText && <p className="benefit-txt">{benefitText}</p>}
            </div>
            {response.unitedPage && response.unitedPage.length > 0 && (
              <div className="cbr-middle">
                <div className="listing-cards">
                  <ul>
                    {response.unitedPage.map((data, index) => {
                      return data ? (
                        <li key={index}>
                          <div className="outerW">
                            <div className="fallback-img"></div>
                            <ImageFallback
                              src={data.imagecropurl_s && data.imagecropurl_s.img1x}
                              alt=""
                              onErrorClass="no-img"
                              className="img-responsive"
                            ></ImageFallback>
                          </div>
                          {data.title_t && <p>{data.title_t}</p>}
                          {data.description_t && <span>{data.description_t}</span>}
                        </li>
                      ) : null;
                    })}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(RegistrationModal);
